import React, { useState, useEffect } from "react";
import Styles from "./Styles.module.css";
import { CiSearch } from "react-icons/ci";
import SidebarField from "../../../../Components/SidebarField";
import { LazyLoadImage } from "react-lazy-load-image-component";

function RightCard(props) {
  const {
    tabs,
    setTab,
    countryData,
    handleSelectedCountry,
    cityData,
    setCityData,
    selectedCity,
    handleCity,
  } = props;

  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const activeIndex = tabs.findIndex((tab) => tab.isActive);
    setActiveTab(activeIndex >= 0 ? activeIndex : 0);
  }, [tabs]);

  const handleClick = (index) => {
    setSearchTerm("");
    const updatedTabs = tabs.map((tab, i) => ({
      ...tab,
      isActive: i === index,
    }));
    setTab(updatedTabs);
    setActiveTab(index);

    if (updatedTabs[1].isActive) {
      setCityData(cityData);
    }
  };

  console.log("selectedcity", selectedCity);

  const filteredCountries = countryData?.data?.filter((country) =>
    country?.country?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const filteredCities = cityData?.data?.filter((city) =>
    city?.city?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  console.log("filteredCity", filteredCities);
  return (
    <SidebarField
      title={<b>{tabs[activeTab]?.tab} INFO</b>}
      footer={false}
      close={false}
    >
      <div className="flex flex-row">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => handleClick(index)}
            className={
              tab.isActive
                ? `${Styles.active} ${Styles.navItem}`
                : Styles.navItem
            }
          >
            {tab.tab}
          </button>
        ))}
      </div>

      <div className={Styles.border_search}>
        <input
          type="text"
          style={{
            border: "none",
            outline: "none",
            backgroundColor: "transparent",
            fontWeight: "bold",
            fontFamily: "Roboto, sans-serif",
            fontSize: "20px",
          }}
          placeholder="Search place"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <CiSearch size={"2rem"} />
      </div>

      {/* Render countries if the first tab is active */}
      {tabs[0].isActive &&
        filteredCountries?.map((c) => (
          <div
            key={c?._id}
            className={Styles.country_list}
            onClick={() => handleSelectedCountry(c)}
          >
            <span>
              <LazyLoadImage
                src={c?.country?.flag}
                alt={c?.country?.name}
                effect="blur"
                className={Styles.country_img}
              />
            </span>
            <span className={Styles.country_details}>
              <h2 className="font-bold">Name: {c?.country?.name}</h2>
              <p>Currency: {c?.currency}</p>
              <p>Symbol: {c?.symbol}</p>
              <p>Native Symbol: {c?.nativeSymbol}</p>
            </span>
          </div>
        ))}

      {/* Render cities if the second tab is active */}
      {tabs[1].isActive &&
        filteredCities?.map((item) => (
          <div
            key={item?._id}
            className={Styles.city_list}
            onClick={() => handleCity(item)}
          >
            <span className={Styles.city_details}>
              <h2 className="text-lg font-bold">{item?.city?.name}</h2>
              {/* {console.log("city.name", city?.name)} */}
              {/* Assuming you want to show related country name */}
              {/* <p>{city?.name}</p> */}
            </span>
          </div>
        ))}
    </SidebarField>
  );
}

export default RightCard;
